export default __webpack_public_path__ + "static/media/5.b462d19b.png";